import React from "react";
import ChildNotesPanel from "../../ChildNotesPanel";

export default function ClassroomNotesPanel({
    childId,
    subjectId,
    subjectName,
    onOpenChange,
    role,
}) {
    if (!childId || !subjectId) {
        return null;
    }

    return (
        <ChildNotesPanel
            role={role}
            childId={childId}
            scope={`classroom_${subjectId}`}
            title={`${subjectName || "Class"} Notes`}
            onOpenChange={onOpenChange}
        />
    );
}